import styled from 'styled-components';

export const AutoCompleteContainer = styled.ul`
  background: #fff;
  list-style-type: none;
  border-radius: 8px;
  min-width: 320px;
  position: absolute;
  top: 100%;
  border: solid 1px #e0e0e0;
  box-shadow: 0px 8px 20px 2px #0000001f;
  left: 0;
  width: 100%;
  margin-top: 10px !important;
  margin: 0;
  padding-left: 20px !important;
  padding-right: 20px !important;
  overflow-y: auto;
  z-index: 1;
  @media (max-width: 768px) {
    min-width: auto;
  }
`;

export const AutoCompleteItem = styled.li`
  padding: 24px 24px;
  width: 100%;
  border-bottom: solid 1px #c4c4c4;
  box-sizing: border-box;
  color: rgba(51, 66, 87, 0.8);
  font-size: 18px;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: #ebf4ff;
  }
  @media (max-width: 768px) {
    padding: 24px 8px;
  }
`;
